/**
 * Arquivo JavaScript principal.
 * A partir daqui são incluídas todas as dependências.
 */

import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Pbh from '@prodabel/piweb-lib-vue';

import router from './routes';
import helpers from './helpers';
import * as filters from './filters';
import AppVue from './App.vue';
import Vuelidate from 'vuelidate'
import store from './store'
import keycloakvue from '@prodabel/vue-keycloak-adapter'
import montaInstanciaAxios from './helpers/montaInstanciaAxios';
import VueGtag from "vue-gtag";
import constantes from './constants';
import routes from './routes/routes.js';

const redirectRote = window.location.href;
const regrasPermissaoRotas = { 
    'USC.21.015': (origem) => origem === 'AD' || origem === 'GovBr',
};

const routesFile = routes.find(route => route.path === '/')?.children;

const routesByName = Object.fromEntries(
    routesFile.map(route => [
        route.name,
        `${process.env.VUE_APP_BASE_URL}${route.path.replace(/^\//, '')}`
    ])
);

function getPathByName () {
    const names = Object.keys(regrasPermissaoRotas);

    const paths = names.map(name => routesByName[name]).filter(Boolean);
    return paths;
}

const redirectUri = `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_BASE_URL}`;

const options = {
    onLoad: 'login-required',
    redirectUri: (getPathByName().includes(window.location.pathname)) ?  redirectRote : redirectUri
};

const permissions = {
    "any": ["home", "403", "404", "USC.21.001", "USC.21.003", "USC.21.006", "USC.21.008", 'USC.21.009', 'USC_21_013'], // Acesso geral
    "guest": [], // Acesso apenas para quem não está logado
    "logged": ['USC.21.004', 'USC.21.005', 'USC.21.007', 'USC.21.010','USC.21.011', 'USC.21.012', 'USC.21.014', 'USC.21.015', 'USC.21.020', 'USC.21.018', 'USC.21.017', 'USC.21.021'] // Acesso apenas para quem está logado
}

const authErrorCallback = function (error) {
    try {
        const erro = JSON.parse(error.message);
        if (erro && erro.response && erro.response.status == 403) {
            alert('Acesso negado.');
            console.log('Auth Original:', error);
        } else {
            alert('Erro inesperado.');
            console.log('Original:', error);
        }
    } catch (e) {
        console.log('Erro ao tratar o erro');
        console.log('Original:', error);  
        console.log('Secundário: ', e);
    }
}

Vue.use(keycloakvue, { store, router, options, authErrorCallback, authorize_disabled: true, permissions, optionsConst: `${redirectUri}keycloak.json` })


router.beforeEach(async (to, from, next) => {
    const regra = regrasPermissaoRotas[to.name];
    const origem = store.getters.userInfo.origem;
    if (regra) {
        if (origem == 'GovBr') {
            if (regra(origem)) {
                next();
                return;
            }
            next({ name: 'home' });
            return;                
        }        

        try {
            const usuario = store.getters.userInfo.preferred_username;
            const resposta = await Vue.prototype.$axios.post(
                Vue.prototype.$env.url_backend + constantes.casosPermissaoAcesso,
                { listaCasoUso: [to.name], usuario }
            );
            const permite = resposta.data.includes(to.name);
            if (permite) {
                next();
            } else {
                next({ name: 'home' });
            }
        } catch (error) {
            console.error('Erro ao verificar permissão de acesso à rota:', error);
            next({ name: 'home' });
        }
    } else {
        next();
        return;
    }
});

Vue.use(Vuelidate)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(Pbh, {
    merge: {
        filters,
        helpers
    }
});

Vue.filter('formatDate', filters.formatDate);
Vue.filter('formatDateTime', filters.formatDateTime);
Vue.filter('formatIndiceCadastral', filters.formatIndiceCadastral);
Vue.filter('formatLancamento', filters.formatLancamento);
Vue.filter('formatCurrency', filters.formatCurrency);
Vue.filter('formatCPFCNPJ', filters.formatCPFCNPJ);

helpers.getEnv(store).then(async (env) => {
    console.log('Env recebido: ', env);
    Vue.prototype.$env = env;
    window.envJson = env;

    window.baseUrl = helpers.baseUrl;
    Vue.prototype.$baseUrl = helpers.baseUrl;
    Vue.prototype.$apiUrl = env.url_backend;

    Vue.prototype.$axios = montaInstanciaAxios(env.apiUrl, store);

    if (env.analyticsId) {
        Vue.use(VueGtag, {
            config: {
                id: env.analyticsId
            }
        }, router);
    }

    new Vue({
        data() {
            return {
                carregando: false,
                recaptchaSiteKey: env.recaptchaSiteKey,
            }
        },
        router,
        store,
        render: h => h(AppVue),
    }).$mount('#app')
});

